<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
	<app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
    <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
        <div class="col-sm-12 px-0 align-self-end">
          <div class="row align-items-center">
            <div class="col-sm-10">
              <h5 class="light-header bold">
                {{ 'MACHINE.LBL_TITLE' | translate}}
              </h5>
            </div>
            <!-- Exit button -->
            <!-- <div class="col-sm-2">
              <button type="button" class="btn btn-primary btn-sm float-right" (click)="exitBtnClickEvent()">
                <i class="fas fa-sign-out"></i> Exit
              </button>
            </div> -->
          </div>
          <hr class="mt-0 mb-3" />
        </div>
        <div class="pt-3">
          <div class="container border rounded p-3 bold">
            <form [formGroup]="iSForm">
              <div class="form-group row">
                <div class="col-sm-4">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addnewmachine()"> <i class="far fa-plus"></i> Add New Machine</button>
                </div>
              </div>
              <div class="form-group row">
                <label for="clinic" class="col-sm-2 col-form-label">Clinic Name</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control bold" id="clinicname" [hidden]="!isAdminUser"  autocomplete="off"
                  [(ngModel)]="clinicname" formControlName="clinicname" disabled/> 
                  <ngx-select-dropdown tabindex="0" class="bold" formControlName="clinicfilter" (change)="clinicFilter()"
                        [multiple]="false"  [(ngModel)]="selectedClinicFilter" [hidden]="isAdminUser"
                        [config]="{displayKey: 'ClinicName',search: true,height:'200px',placeholder:'Select Clinic',searchOnKey: 'ClinicName' }" 
                        [options]="clinicsforfilter">
                  </ngx-select-dropdown> 
                </div>
              </div>
              <div class="form-group row">
                <label for="location" class="col-sm-2 col-form-label">Location</label>
                <div class="col-sm-4">
                  <ngx-select-dropdown tabindex="0" class="bold" formControlName="locationfilter" (change)="locationFilter()"
                        [multiple]="false"  [(ngModel)]="selectedLocationFilter"
                        [config]="{displayKey: 'LocationName',search: true,height:'200px',placeholder:'Select Location',searchOnKey: 'LocationName' }" 
                        [options]="locationsforfilter">
                  </ngx-select-dropdown> 
                </div>
              </div>
              <div class="form-group row">
                  <label for="Name" class="col-sm-2 col-form-label">Machine Name</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control bold" id="name" autocomplete="off"
                    formControlName="name" [(ngModel)]="name" (keyup)="searchBtnClickEvent()"/> 
                  </div>
                  <div class="col-sm-5">
                    <div class="form-row">
                      <!-- <div class="form-group col-md-0">
                        <button type="button" class="btn btn-primary btn-sm" (click)="searchBtnClickEvent()"> <i class="far fa-search"></i> Search</button>
                      </div> -->
                      <div class="form-group col-md-0">
                        <button type="button" class="btn btn-primary btn-sm" (click)="cancelBtnClickEvent()"> <i class="far fa-times"></i> Cancel</button>
                      </div>
                    </div>
                  </div>
              </div>
            </form>
          </div>
		  </div>
		<div class="pt-3">
			<div class="container border rounded p-3 bold">
				<div id="grid-wrapper" class="col-sm-12 px-0" style="width: 100%; overflow: hidden;">
					<div class="col-sm-12 px-0" >
					  <ag-grid-angular style="width: 100%; height: 500px; " class="ag-theme-balham bold"
						[columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [rowData]="rowData"
            (gridSizeChanged)="gridSizeChanged($event)" [defaultColDef]="defaultColDef"
            [animateRows]="true" [isExternalFilterPresent]="isExternalFilterPresent"
            [doesExternalFilterPass]="doesExternalFilterPass"
						[headerHeight]="60" [gridOptions]="gridOptions" >
					  </ag-grid-angular>
					</div>
				</div>
			</div>
		  </div>
      </div>
    </div>

    <ng-template #add_edit_Machine>
      <div class="modal-md">
        <div class="modal-header">
            <h5 class="modal-title" [hidden]="updateMode">Add New Machine</h5>
            <h5 class="modal-title" [hidden]="!updateMode">Edit Machine</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelModal()">
              <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
        <div class="container-fluid bold">
              <div>
                <div class="container border rounded p-3 bold">
                    <form [formGroup]="iSForm">
                      <div class="form-group row">
                        <label for="clinic" class="col-sm-4 col-form-label">Clinic Name</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control bold" id="clinicname" [hidden]="!(isAdminUser || updateMode)"  autocomplete="off"
                          [(ngModel)]="clinicname" formControlName="clinicname" disabled/> 
                          <ngx-select-dropdown tabindex="0" class="bold" formControlName="clinic" (change)="selectedClinic($event)"
                                [multiple]="false"  [(ngModel)]="selectedClinicItem" [hidden]="(isAdminUser || updateMode)"
                                [config]="{displayKey: 'ClinicName',search: true,height:'200px',placeholder:'Select Clinic',searchOnKey: 'ClinicName' }" 
                                [options]="clinics">
                          </ngx-select-dropdown>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="location" class="col-sm-4 col-form-label">Location</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control bold" id="locationname" [hidden]="!updateMode"  autocomplete="off"
                          [(ngModel)]="locationname" formControlName="locationname" disabled/> 
                          <ngx-select-dropdown tabindex="0" class="bold" formControlName="location" (change)="selectedLocation($event)"
                                [multiple]="false"  [(ngModel)]="selectedLocationItem" [hidden]="updateMode"
                                [config]="{displayKey: 'LocationName',search: true,height:'200px',placeholder:'Select Location',searchOnKey: 'LocationName' }" 
                                [options]="locations">
                          </ngx-select-dropdown>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="equipment" class="col-sm-4 col-form-label">Equipment</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control bold" id="equipmentname" [hidden]="!updateMode"  autocomplete="off"
                          [(ngModel)]="equipmentname" formControlName="equipmentname" disabled/> 
                          <!-- <ngx-select-dropdown tabindex="0" class="bold" formControlName="equipment" (change)="selectedEquipment($event)"
                                [multiple]="false"  [(ngModel)]="selectedEquipmentItem" [hidden]="updateMode"
                                [config]="{displayKey: 'EquipmentName',search: true,height:'200px',placeholder:'Select Equipment',searchOnKey: 'EquipmentName' }" 
                                [options]="equipments">
                          </ngx-select-dropdown> -->
                          <select name="equipment" class="form-control bold" style="font-size: 14px;" [(ngModel)]="equipment" formControlName="equipment" [hidden]="updateMode">
                            <option *ngFor="let equipment of equipments" [ngValue]="equipment">{{equipment.EquipmentName}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="machinename" class="col-sm-4 col-form-label">Machine Name</label>
                        <div class="col-sm-8"> 
                           <input type="text" class="form-control bold" id="machinename" autocomplete="off"
                           [(ngModel)]="machinename" formControlName="machinename"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="macaddress" class="col-sm-4 col-form-label">Mac Address</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="macaddress" autocomplete="off"
                            [(ngModel)]="macaddress" formControlName="macaddress"/> 
                        </div>
                      </div>
                      <div class="form-group row" [id]="id" [hidden] = "!updateMode || isAdminUser">
                        <label for="isactive" class="col-sm-4 col-form-label">Status</label>
                        <div class="col-sm-8">
                          <div class="row">
                            <input type="radio" autocomplete="off" formControlName="isactive" [(ngModel)]="isactive" name="isactive" [checked]="isactive == true ? true: false" class="form-control bold col-sm-1 float-right" id="active" value=true>
                            <label for="active" class="col-sm-3 col-form-label">Active</label>
                            <input type="radio" autocomplete="off" formControlName="isactive" [(ngModel)]="isactive" name="isactive"  [checked]="isactive != true ? true: false" class="form-control bold col-sm-1 float-right" id="inactive" value=false>
                            <label for="inactive" class="col-sm-3 col-form-label">Inactive</label>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
              </div>
          </div>
        </div>
        <div class="modal-footer">
            <div class="form-group col-md-0">
              <button type="button" class="btn btn-primary btn-sm" (click)="saveMachineDetails()"> <i class="far fa-save"></i> Save</button>
            </div>
            <div class="form-group col-md-0">
              <button type="button" class="btn btn-primary btn-sm" (click)="cancelModal()"> <i class="far fa-times"></i> Cancel</button>
            </div>
        </div>
      </div>
      </ng-template>